import React, { useState, useEffect } from 'react';

import Modal from '../base/Modal';

const SelectFunctions = ({ selectedValue, isOpen, onClose, onSave }) => {
  const [selectedFunctions, setSelectedFunctions] = useState([]);

  useEffect(() => {
    // Reset selected functions when modal opens
    if (isOpen) {
      setSelectedFunctions([]);
    }
  }, [isOpen]);

  return (
    <Modal
      title={
        <div className="flex flex-1 items-center gap-3">
          <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border border-neutral-400 bg-neutral-100 p-0.5">
            {selectedValue?.image && (
              <img
                alt={selectedValue?.label || ''}
                loading="lazy"
                width="24"
                height="24"
                src={selectedValue.image}
              />
            )}
          </div>
          <span className="paragraph-1 font-semibold capitalize">
            {selectedValue?.label || ''}
          </span>
        </div>
      }
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="flex min-h-96 flex-col justify-between gap-3 p-5 px-8">
        <div className="flex flex-col gap-2">
          {selectedValue?.functions?.map((item, index) => (
            <button
              key={index}
              className={`text-s-text rounded-lg px-3 py-2 text-sm transition-all duration-200 ${
                selectedFunctions.includes(item)
                  ? 'bg-zinc-100 text-zinc-800 hover:bg-zinc-300'
                  : 'bg-zinc-800 text-zinc-100 hover:bg-zinc-700 hover:text-zinc-100'
              }`}
              onClick={() => {
                if (selectedFunctions.includes(item)) {
                  setSelectedFunctions(
                    selectedFunctions.filter((f) => f !== item),
                  );
                } else {
                  setSelectedFunctions([...selectedFunctions, item]);
                }
              }}
            >
              <div className="flex flex-1 items-center gap-3">
                <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border border-neutral-400 bg-neutral-100 p-0.5">
                  {selectedValue?.image && (
                    <img
                      alt={selectedValue?.label || ''}
                      loading="lazy"
                      width="24"
                      height="24"
                      src={selectedValue.image}
                    />
                  )}
                </div>
                <span className="paragraph-1 font-semibold capitalize">
                  {selectedValue?.label || ''}:{' '}
                  {item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}
                </span>
              </div>
            </button>
          ))}
        </div>
        <div>
          <button
            className="rounded-lg border border-zinc-700 bg-zinc-800 px-3 py-1 text-sm"
            onClick={() => onSave(selectedFunctions)} // Trigger the onSave callback with selected functions
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SelectFunctions;
